// @flow

import React from 'react';
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';
import './membership-no.scss';

export default class MembershipNoModal extends React.Component {
  props: Props;

  constructor() {
    super();
    this.handleCopyMembershipNumber = this.handleCopyMembershipNumber.bind(this);
    this.handleOutsideMenuTouch = this.handleOutsideMenuTouch.bind(this);
    this.stopPropagation = this.stopPropagation.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleOutsideMenuTouch);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideMenuTouch);
  }

  handleOutsideMenuTouch() {
    const { closeMembershipModal } = this.props;
    closeMembershipModal();
  }

  stopPropagation(event) {
    event.nativeEvent.stopImmediatePropagation();
  }

  handleCopyMembershipNumber(event) {
    const { user, copyMembershipNumber } = this.props;
    const el = document.createElement('textarea');
    el.value = user.cae;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    copyMembershipNumber();
    if (event.nativeEvent) {
      event.nativeEvent.preventDefault();
      event.nativeEvent.stopImmediatePropagation();
    }
  }

  render() {
    const { membershipModalIsOpen, closeMembershipModal, membershipNumberCopied } = this.props;
    return (
      <Modal isOpen={membershipModalIsOpen} onClick={this.stopPropagation} className="modal-dialog-centered membership-no-modal">
        <ModalHeader>
          Membership number
          <button type="button" className="close" onClick={closeMembershipModal} aria-label="Close">
            <svg width="17px" height="17px" className="inner-icon" viewBox="0 0 21 21" version="1.1">
              <title>Cross</title>
              <path d="M0,1 L19,20 L20,18 L2,0 L0,2 Z" fill="#071c64" />
              <path d="M19,0 L0,19 L2,20 L20,2 L18,0 Z" fill="#071c64" />
            </svg>
          </button>
        </ModalHeader>
        <ModalBody>
          <p>
            {'Your Membership number, also known as '}
            {'your CAE or IPI, uniquely identifies '}
            {'your account.'}
          </p>
        </ModalBody>
        <ModalFooter>
          {membershipNumberCopied ? (
            <button
              type="button"
              className="btn btn-outline-dark btn-block"
              onClick={closeMembershipModal}
            >
              Close
            </button>
          ) :
            (
              <button
                type="button"
                className="btn btn-outline-dark btn-block"
                onClick={this.handleCopyMembershipNumber}
                onTouchEnd={this.handleCopyMembershipNumber}
              >
                Copy Number
              </button>
            )
          }
        </ModalFooter>
      </Modal>
    );
  }
}
